import ChartBar from "../chart-bar";
import {
  differenceInCalendarDays,
  getOverlappingDaysInIntervals,
  startOfDay,
  endOfDay
} from "date-fns";

const start = (task: Interval, chart: Interval) =>
  Math.max(differenceInCalendarDays(task.start, chart.start), 0);

const span = (task: Interval, chart: Interval) => {
  const t = {
    start: startOfDay(task.start),
    end: endOfDay(task.end)
  };
  try {
    return getOverlappingDaysInIntervals(t, chart);
  } catch (e) {
    console.error("invalid interval details", task, t, chart);
    throw e;
  }
};

export function create(task: Interval, chart: Interval) {
  return new ChartBar({ start: start(task, chart), span: span(task, chart) });
}

export default { create };
